import React from "react";
import { Container, Row, Col, Card, Badge, Button } from "react-bootstrap";
import { Wallet, Landmark, PhoneCall, CheckCircle, Info, Copy } from "lucide-react";
import Header from "./Header";
import Footer from "./Footer";
import SideMenu from "./SideMenu";
import MemberMenu from "./MemberMenu";
import AdminMenu from "./AdminMenu";
import Logout from "./Logout";
import { useAuth } from "./Home1";

const BuySmsOnline = () => {
  const { user } = useAuth();
  const isAdmin = user?.id === "71";

  React.useEffect(() => {
    document.title = "Buy SMS Online - beaconSMS";
  }, []);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    // You can add a small Toast notification here if you have one
  };

  return (
    <Container className="pb-5">
      <Header user={user} />

      <Row className="mt-4 px-md-3">
        {/* Side Menu Column */}
        <Col md="3" className="mb-4 mb-md-0">
          <Logout Menu="Login Menu" user={user?.username} />
          <SideMenu Menu="Member's Menu" menuu={MemberMenu} />
          {isAdmin && <SideMenu Menu="Admin's Menu" menuu={AdminMenu} />}
        </Col>

        {/* Main Content Area */}
        <Col md="9">
          <div className="d-flex align-items-center mb-4 border-bottom pb-3">
            <Wallet className="text-primary me-2" size={28} />
            <h3 className="mb-0 fw-bold text-primary">Purchase SMS Units</h3>
          </div>

          <Row className="justify-content-center">
            <Col lg={10}>
              <Card className="shadow-sm border-0 rounded-4 overflow-hidden">
                {/* Header Section with Price Badge */}
                <div className="bg-primary p-4 text-white text-center position-relative">
                  <h5 className="mb-1 fw-bold">Simple & Affordable Pricing</h5>
                  <div className="mt-2">
                    <Badge bg="light" text="primary" className="p-2 px-3 fs-6 rounded-pill shadow-sm">
                      ₦2.50 / Unit
                    </Badge>
                  </div>
                </div>

                <Card.Body className="p-4 p-md-5">
                  <Row className="align-items-center mb-4">
                    <Col sm={8}>
                      <h5 className="fw-bold mb-3 d-flex align-items-center">
                        <Landmark className="me-2 text-primary" size={20} />
                        Bank Transfer Details
                      </h5>
                      <p className="text-muted small">
                        Please use your username <Badge bg="warning" text="dark">{user?.username || 'Username'}</Badge> as the depositor's name or transfer narration for instant tracking.
                      </p>
                    </Col>
                    <Col sm={4} className="text-center text-sm-end">
                      {/* GTBank Logo Placeholder - Use a real PNG URL if available */}
                      <img 
                        src="https://img.logokit.com/gtbank.com?token=pk_fr215b89fe27deb98ebd7d" 
                        alt="GTBank Logo" 
                        style={{ width: '80px', objectFit: 'contain' }}
                        className="mb-2"
                      />
                    </Col>
                  </Row>

                  {/* Bank Details Table/Box */}
                  <div className="bg-light p-4 rounded-4 border">
                    <Row className="gy-3">
                      <Col md={6}>
                        <label className="text-uppercase text-muted fw-bold mb-1" style={{ fontSize: '11px' }}>Bank Name</label>
                        <p className="fw-bold mb-0">GUARANTY TRUST BANK (GTB)</p>
                      </Col>
                      <Col md={6}>
                        <label className="text-uppercase text-muted fw-bold mb-1" style={{ fontSize: '11px' }}>Account Name</label>
                        <p className="fw-bold mb-0 text-primary">E&L TECH SOLUTIONS LIMITED</p>
                      </Col>
                      <Col md={12}>
                        <label className="text-uppercase text-muted fw-bold mb-1" style={{ fontSize: '11px' }}>Account Number</label>
                        <div className="d-flex align-items-center">
                          <h2 className="fw-bold text-dark mb-0 letter-spacing-1">0158543353</h2>
                          <Button 
                            variant="outline-primary" 
                            size="sm" 
                            className="ms-3 rounded-circle"
                            onClick={() => copyToClipboard("0158543353")}
                          >
                            <Copy size={14} />
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  {/* Features / Steps */}
                  <Row className="mt-4 g-3">
                    <Col md={6}>
                      <div className="d-flex align-items-start p-2">
                        <CheckCircle className="text-success me-2 mt-1" size={18} />
                        <small className="text-muted">Automatic credit after payment confirmation.</small>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="d-flex align-items-start p-2">
                        <Info className="text-info me-2 mt-1" size={18} />
                        <small className="text-muted">Large purchases (1M+ units) attract special discounts.</small>
                      </div>
                    </Col>
                  </Row>

                  <hr className="my-4" />

                  {/* Support Footer */}
                  <div className="text-center">
                    <p className="text-muted mb-2 small">Need help with your purchase?</p>
                    <Button 
                      variant="outline-dark" 
                      className="rounded-pill px-4 d-inline-flex align-items-center fw-bold"
                      href="tel:+2348083814362"
                    >
                      <PhoneCall size={16} className="me-2 text-primary" />
                      Contact Support: 0808 381 4362
                    </Button>
                  </div>
                </Card.Body>
              </Card>

              {/* Secure Payment Note */}
              <p className="text-center mt-4 text-muted small">
                <Badge bg="secondary" className="me-2">100% SECURE</Badge>
                Verified Bank Transfer Method
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
      <Footer />
    </Container>
  );
};

export default BuySmsOnline;